import TonalButton from '@/components/TonalButton';
import { type Tag } from '@/lib/types';
import { useContext, useState } from 'react';
import { AddCircleOutlineOutlined as AddIcon } from '@mui/icons-material';
import { Button, TextField } from '@mui/material';
import styled from '@emotion/styled';
import type React from 'react';
import useApi from '@/lib/api/useApi';
import TagsContext from './TagsContext';
import { FormattedMessage } from 'react-intl';

const FormWrapper = styled('form')({
  display: 'flex',
  '.MuiTextField-root': {
    marginRight: 12,
    width: 256,
  },
});

const CreateTag = () => {
  const api = useApi();
  const [, setTags] = useContext(TagsContext);

  const [formOpen, setFormOpen] = useState(false);

  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  if (!formOpen) {
    return (
      <TonalButton onClick={() => setFormOpen(true)} startIcon={<AddIcon />}>
        <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.create_tag.button" />
      </TonalButton>
    );
  }

  const saveNewTag = async (
    e: React.SubmitEvent<HTMLFormElement>,
  ): Promise<void> => {
    e.preventDefault();

    setSaving(true);

    const tag = await api.post<Tag>('editor/tags', {
      name: name.trim(),
    });

    setTags(tags => {
      tags[tag.id] = tag;
    });

    setSaving(false);
    setFormOpen(false);
    setName('');
  };

  return (
    <FormWrapper onSubmit={saveNewTag}>
      <TextField
        label={
          <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.create_tag.form.input_label" />
        }
        size="small"
        value={name}
        onChange={e => setName(e.target.value)}
        disabled={saving}
        autoFocus
      />
      <Button
        type="submit"
        variant="contained"
        loading={saving}
        disabled={name.trim().length === 0}
        disableElevation
      >
        <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.create_tag.form.create_button" />
      </Button>
    </FormWrapper>
  );
};

export default CreateTag;
